import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=323b9588&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=323b9588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323b9588",
  null
  
)

export default component.exports